import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // embedされている新・旧単位変換テーブル
    csvReplaceTable: [],
    // 加工したspec
    specsList: [],
    specBorder: { total: 0, freeTotal: 0},
    resultJson: {},
    judgeDFList: [],
    remainList: [],
    courceLabels: [], // [{Y7: 'デザイン', Y11: 'hoge..}]
    senmon: {},

    ignoreStudents: null
  },
  mutations: {
    updateCsvReplaceTable (state, { table }) {
      state.csvReplaceTable = table
    },
    updateSpecsList ( state, { specsList }) {
      state.specsList = specsList
    },
    updateResultJson ( state, { resultJson }) {
      state.resultJson = resultJson
    },
    updateJudgeDFList (state, { list }) {
      state.judgeDFList = list
    },
    updateRemainList (state, { list }) {
      state.remainList = list
    },
    updateSpecBorder (state, { specBorder }) {
      state.specBorder = specBorder
    },
    updateCourceLabels (state, { courceLabels }) {
      state.courceLabels = courceLabels
    },
    updateSenmon (state, { senmon }) {
      state.senmon = senmon
    },
    updateIgnoreStudents (state, { list }) {
      state.ignoreStudents = list
    }
  },
  actions: {

  }
})
